module.exports = __webpack_public_path__ + "static/media/imagemHorasol.67ab683e.jpg";